import { axiosInstance } from 'src/modules/api';
import { IApiResponse } from './shared.interface';


export function getCurrentContract() {
  return axiosInstance.get<IApiResponse<IApiContract>>('/api/Contract/current');
}
export interface IApiContract {
  houseName:          string;
  roomBedName:        string;
  houseAddress:       string;
  depositAmount:      number;
  invoiceType:        number;
  interestRate:       number;
  status:             number;
  terminationType:    number;
  terminationReason:  string;
  signDate:           string;
  startDate:          string;
  endDate:            string;
  terminationDate:    string;
  monthlyRentItems:   IContractItem[];
  managementFeeItems: IContractItem[];
  otherItems:         IContractItem[];
}

export interface IContractItem {
  name:        string;
  description: string;
  amount:      number;
  category:    number;
}



// WEBPACK FOOTER //
// ./src/crud/contract.crud.ts